import React, { useState } from 'react'
import Sidebar from "../../../../components/dashboard/institute/sidebar/sidebar.js"
import articledashboard from "../../../../assets/images/articledashboard.svg";
import { Footer } from '../../../common/footer/footer';
import { Pagination } from '../../../common/pagination/uiPagination.js';
import { Trans, useTranslation } from "react-i18next";
import "../myBlogs/blogs.model.css";
import { ArticlesCardJSX } from '../../../common/articlesCard/articlesCard';
export const BlogJSX = (props) => {
    const { blogData, onPaginationButtonClick, onPaginationButtonClick1, expertData, page, page1, expertBlogData } = props;
    const itemsPerPage = 8
    const [currentPage] = useState(1);
    const currentItems = blogData?.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
    );
    const currentItems1 = expertBlogData?.slice(
        (page1 - 1) * itemsPerPage,
        page1 * itemsPerPage
    );
    const { t } = useTranslation();
    return (
        <section className="main_institute_dashboard">
            <section className="entiredashboard maincustomerdash main institute_dashboard">
                <div className="container-fluid">
                    <div className="row dashboard-decoration">
                        <div className="col-lg-4 col-sm-4">
                            <Sidebar />
                        </div>
                        <div className="col-lg-8 col-sm-8 dashboard-data-inst blog-in">
                            <div className="dashboardrightpannerinnerleft dashboardrightpanel">
                            <h2 className="h2_style font-weight-600 d-block d-lg-none d-sm-none d-md-none"><span className="headingicon d-block d-lg-none d-sm-none d-md-none "><img alt="article" src={articledashboard} /></span>{t("BLOG.TITLE")}</h2>
                                <div className="sectionheader martop20 marbot20 blogsectionpos">
                                    <p className="dahsboardTitle  d-none d-sm-block">{t("BLOG.TITLE")}</p>
                                    <p className="dahsboardSubTitle"><Trans i18nKey="BLOG.WRITTENARTICAL"></Trans> </p>
                                </div>
                                <div className="dashboardblog" id="articlePanel">
                                    <p className="dahsboardTitle">{t("instituteDashboard.EXPERTAUTHOR")}</p>
                                    <p className="dahsboardSubTitle">{t("instituteDashboard.REGISTERED")} </p>
                                    <div className="d-none d-sm-block">
                                        <div className="expert-all-blog">
                                            {
                                                (currentItems1?.length > 0) ?
                                                    currentItems1?.map(blog => {
                                                        return <div className={`col-lg-3 col-md-6 col-sm-6 p-0 blogblogmain ${blog.cats[0].cat_name?.replace(/\s+/g, '')}`} key={blog.id}>
                                                            <div className="blog-margin">   <div className={`basicstructure`}>
                                                                <ArticlesCardJSX blogslug={blog?.slug}
                                                                    //() => { setBlog(blog); setOpenModal(true)
                                                                    blogimage={blog?.image}
                                                                    blogtitle={blog?.title}
                                                                    articleauthor={blog?.author}
                                                                    blogcat={blog?.cats?.[0].name}
                                                                    articledatepublish={blog?.date_publish}
                                                                    isSerchArticle={false} />

                                                            </div>
                                                            </div>
                                                        </div>
                                                    }) :
                                                    <div className="empthy-blog">
                                                       
                                                        <div>
                                                            <h5>{t("instituteDashboard.NOBLOGS")}</h5>

                                                        </div>
                                                    </div>
                                            }

                                        </div></div>

                                    <div className="innerfeaturedblog d-block d-lg-none d-sm-none d-md-none ">
                                        <div className="expert-all-blog">
                                            {

                                                (expertData?.length > 0 && currentItems1?.length) ?
                                                    currentItems1?.map(blog => {
                                                        return <div className={`col-lg-3 col-md-6 col-sm-6 p-0 smblog blogblogmain ${blog.cats[0].cat_name?.replace(/\s+/g, '')}`} key={blog.id}>
                                                            <div className="blog-margin">   <div className={`basicstructure`}>
                                                                <ArticlesCardJSX blogslug={blog?.slug}
                                                                    //() => { setBlog(blog); setOpenModal(true)
                                                                    blogimage={blog?.image}
                                                                    blogtitle={blog?.title}
                                                                    articleauthor={blog?.author}
                                                                    blogcat={blog?.cats?.[0].name}
                                                                    articledatepublish={blog?.date_publish}
                                                                    isSerchArticle={true} />

                                                            </div>
                                                            </div>
                                                        </div>
                                                    }) :
                                                    <div className="empthy-blog">
                                                        
                                                        <div>
                                                            <h5>{t("instituteDashboard.NOBLOGS")}</h5>

                                                        </div>
                                                    </div>
                                            }

                                        </div></div>
                                    {currentItems1?.length && <section className="newpagination"> <Pagination
                                        currentPage={currentPage}
                                        page={page1}
                                        allOffersData={expertBlogData}
                                        currentItems={currentItems1}
                                        onPaginationButtonClick={onPaginationButtonClick1}
                                        itemsPerPage={itemsPerPage}
                                    /></section>}
                                </div>


                                <div className="dashboardblog dashboardexpert" id="articlePanel2">
                                    <p className="dahsboardTitle">{t("instituteDashboard.PRODUCTS")}</p>
                                    <p className="dahsboardSubTitle">{t("instituteDashboard.PRODUCTSDESC")} </p>
                                    <div className="d-none d-sm-block">
                                        <div className="expert-all-blog">
                                            {
                                                blogData?.length > 0 ?
                                                    currentItems?.map(blog => {

                                                        return <div className={`col-lg-3 col-md-3 col-sm-6 p-0 blogblogmain ${blog.cats[0].cat_name?.replace(/\s+/g, '')}`} key={blog.id}>
                                                            <div className="blog-margin">   <div className={`basicstructure ${blog.cats[0]?.name}`}>
                                                                <ArticlesCardJSX blogslug={blog?.slug}
                                                                    blogimage={blog?.image}
                                                                    blogtitle={blog?.title}
                                                                    articleauthor={blog?.author}
                                                                    blogcat={blog?.cats?.[0].name}
                                                                    articledatepublish={blog?.date_publish}
                                                                    isSerchArticle={false} />

                                                            </div>
                                                            </div>
                                                        </div>

                                                    }) :
                                                    <div className="empthy-blog">
                                                      
                                                        <div>
                                                            <h5>{t("instituteDashboard.NOBLOGS")}</h5>

                                                        </div>
                                                    </div>

                                            }
                                        </div>
                                    </div>
                                    <div className="innerfeaturedblog d-block d-lg-none d-sm-none d-md-none ">
                                        <div className="expert-all-blog">
                                            {
                                                blogData?.length > 0 ?
                                                    currentItems?.map(blog => {

                                                        return <div className={`col-lg-3 col-md-3 col-sm-6 p-0 smblog blogblogmain ${blog.cats[0].cat_name?.replace(/\s+/g, '')}`} key={blog.id}>
                                                            <div className="blog-margin">   <div className={`basicstructure ${blog.cats[0]?.name}`}>
                                                                <ArticlesCardJSX blogslug={blog?.slug}
                                                                    blogimage={blog?.image}
                                                                    blogtitle={blog?.title}
                                                                    articleauthor={blog?.author}
                                                                    blogcat={blog?.cats?.[0].name}
                                                                    articledatepublish={blog?.date_publish}
                                                                    isSerchArticle={true} />

                                                            </div>
                                                            </div>
                                                        </div>

                                                    }) :
                                                    <div className="empthy-blog">
                                                       
                                                        <div>
                                                            <h5>{t("instituteDashboard.NOBLOGS")}</h5>

                                                        </div>
                                                    </div>

                                            }
                                        </div>
                                    </div>
                                    {currentItems?.length && <section className="newpagination"> <Pagination
                                        currentPage={currentPage}
                                        page={page}
                                        allOffersData={blogData}
                                        currentItems={currentItems}
                                        onPaginationButtonClick={onPaginationButtonClick}
                                        itemsPerPage={itemsPerPage}
                                    /></section>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </section>
    )
}